"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToggleMore = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var cns = {
    'light-blue': ['br-p-4', 'br-bg-blue-100'],
    gray: ['br-p-4', 'br-bg-gray-300'],
    transparent: ['br-bg-none']
};
var ToggleMore = function (_a) {
    var type = _a.type, isOpen = _a.isOpen, label = _a.label, toggle = _a.toggle, className = _a.className, children = _a.children, unused = __rest(_a, ["type", "isOpen", "label", "toggle", "className", "children"]);
    return (react_1.default.createElement("div", __assign({ className: (0, classnames_1.default)(className, cns[type]) }, unused),
        react_1.default.createElement("div", { style: isOpen ? undefined : { WebkitMaskImage: 'linear-gradient(180deg, rgb(0, 0, 0), 40%, rgba(0, 0, 0, 0) 95% )' }, className: (0, classnames_1.default)({ 'br-max-h-20': !isOpen }) }, children),
        react_1.default.createElement("div", { onClick: toggle }, label)));
};
exports.ToggleMore = ToggleMore;
